// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3fe3bd7d","404":"5d534434","498":"8bef3ec0"}[chunkId] + ".chunk.js";
};